import { DEFAULT_CURRENCY } from 'constants/currencies'

import ExchangeRateHttpClient from './instance/exchangeRate'

export const GET_EXCHANGE_RATE = (currency = DEFAULT_CURRENCY) =>
    ExchangeRateHttpClient({
        method: 'get',
        url: `/currencies/${currency.toLowerCase()}.json`,
    })
